import script from "./WorkspaceStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceStep.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceStep.vue?vue&type=style&index=0&id=45e9d6b3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e9d6b3"]])

export default __exports__